import React from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, FormGroup, Label, Input, InputGroup } from 'reactstrap';
import { useMutation } from 'react-apollo';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash-es';
import { CustomButton } from '../../../containers';
import { AdminReprintInvoiceMutation } from '../../../operations/mutations/AdminUserTransactionMutation';
import { handleRequestError } from '../../../constants/errorCodes';
import { saveFileToDevice } from '../../../utils/generateFile';

export const InvoiceInfoSection = React.memo(({ confirmationCode, referenceNumber }) => {
  const dispatch = useDispatch();

  const [rePrintInvoice] = useMutation(AdminReprintInvoiceMutation, {
    variables: { paymentId: confirmationCode },
    onError: error => handleRequestError(error, dispatch),
    onCompleted: data => {
      const invoiceData = get(data, 'reprintInvoice', {});
      if (invoiceData.base64) {
        saveFileToDevice(`račun-${referenceNumber}.pdf`, invoiceData.base64);
      }
    },
    fetchPolicy: 'no-cache',
  });

  return (
    <Row className="no-gutters my-4">
      <Col xs="12">
        <Row className="no-gutters">
          <Col xs="12">
            <h3 className="mb-4">
              <FormattedMessage id="adminUserTransactionsPage.invoiceInfo" />
            </h3>
          </Col>
        </Row>
        <FormGroup row>
          <Col xs="12" sm="6">
            <Label for="invoiceNumber">
              <FormattedMessage id="inputs.invoiceNumber" />
            </Label>
            <InputGroup>
              <Input className="hok-standard-input" id="invoiceNumber" readOnly defaultValue={referenceNumber} />
              <CustomButton
                className="hok-dashboard-btn d-none d-xl-inline-block ml-0 ml-sm-3"
                block={false}
                translationId="downloadInvoice"
                disabled={!referenceNumber}
                onClick={referenceNumber ? rePrintInvoice : () => null}
              />
            </InputGroup>
          </Col>
          <Col xs="12" sm="6" className="d-flex align-items-end">
            <CustomButton
              className="hok-dashboard-btn d-block w-xs-100 d-sm-inline-block d-xl-none mb-0 mb-sm-3"
              block={false}
              translationId="downloadInvoice"
              disabled={!referenceNumber}
              onClick={referenceNumber ? rePrintInvoice : () => null}
            />
          </Col>
        </FormGroup>
      </Col>
    </Row>
  );
});
